<template>
  <div class="view-container">
    <keep-alive>
      <router-view class="view"></router-view>
    </keep-alive>
  </div>
</template>

<script>
  export default {
    name: 'view-container'
  }
</script>



// WEBPACK FOOTER //
// ViewContainer.vue?1a161fce